export const trackEvent = (eventName: string, properties: Record<string, any> = {}) => {
  // Track with Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, properties);
  }

  // Track with TikTok Pixel
  if (window.ttq) {
    window.ttq.track(eventName, properties);
  }
};

export const trackPurchase = (orderDetails: {
  orderId: string;
  value: number;
  currency: string;
  items: Array<{
    item_name: string;
    price: number;
  }>;
}) => {
  // Track with Google Analytics
  if (window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: orderDetails.orderId,
      value: orderDetails.value,
      currency: orderDetails.currency,
      items: orderDetails.items
    });
  }

  // Track with TikTok Pixel
  if (window.ttq) {
    window.ttq.track('CompletePayment', {
      content_type: 'product',
      content_id: orderDetails.orderId,
      value: orderDetails.value,
      currency: orderDetails.currency
    });
  }
};

export const trackAddToCart = (details: {
  value: number;
  currency: string;
  items: Array<{
    item_name: string;
    price: number;
  }>;
}) => {
  // Track with Google Analytics
  if (window.gtag) {
    window.gtag('event', 'add_to_cart', {
      currency: details.currency,
      value: details.value,
      items: details.items
    });
  }

  // Track with TikTok Pixel
  if (window.ttq) {
    window.ttq.track('AddToCart', {
      contents: details.items,
      value: details.value,
      currency: details.currency
    });
  }
};

export const trackBeginCheckout = (details: {
  value: number;
  currency: string;
  items: Array<{
    item_name: string;
    price: number;
  }>;
}) => {
  // Track with Google Analytics
  if (window.gtag) {
    window.gtag('event', 'begin_checkout', {
      currency: details.currency,
      value: details.value,
      items: details.items
    });
  }

  // Track with TikTok Pixel
  if (window.ttq) {
    window.ttq.track('InitiateCheckout', {
      contents: details.items,
      value: details.value,
      currency: details.currency
    });
  }
};